module.exports = __webpack_public_path__ + "img/right_pet_button.81b3c4c3.jpg";